import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-156f40de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "createSurveyModal" }
const _hoisted_2 = { class: "createSurveyModalContent p-6" }
const _hoisted_3 = { class: "formHolder" }
const _hoisted_4 = { class: "header headline3 mb-5" }
const _hoisted_5 = { class: "sectionItem mb-4" }
const _hoisted_6 = { class: "label" }
const _hoisted_7 = { class: "value" }
const _hoisted_8 = { class: "sectionItem mb-4" }
const _hoisted_9 = { class: "label" }
const _hoisted_10 = { class: "value" }
const _hoisted_11 = {
  key: 0,
  class: "createObjectButton mb-2"
}
const _hoisted_12 = { class: "sectionItem mb-4" }
const _hoisted_13 = { class: "label" }
const _hoisted_14 = { class: "value-bg-transparent" }
const _hoisted_15 = { class: "sectionItem mb-4" }
const _hoisted_16 = { class: "label" }
const _hoisted_17 = {
  id: "openDateTimeModal",
  class: "value"
}
const _hoisted_18 = { class: "sectionItem mb-16" }
const _hoisted_19 = { class: "label" }
const _hoisted_20 = { class: "value" }
const _hoisted_21 = { class: "buttonsHolder" }
const _hoisted_22 = { class: "dateTimeContent p-6" }
const _hoisted_23 = { class: "dateTimeHolder pb-16" }
const _hoisted_24 = { class: "buttonHolder" }

import { getCache, setCache } from '@/store/storage/ionicStorage';
import { IonCheckbox, IonContent, IonItem, IonLabel, IonModal, modalController, useIonRouter } from '@ionic/vue';
import { ComputedRef, computed, onMounted, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
//Components
import AButton from "@/components/Base/AButton";
import AppDateTime from '@/components/v2/App/AppDateTime.vue';
import AppInput from '@/components/v2/App/AppInput.vue';
import AppMap from '@/components/v2/App/AppMap.vue';
import AppSelect from '@/components/v2/App/AppSelect.vue';
//Composables
import { useCreateSurvey } from '@/composables/useCreateSurvey';
import useUser from "@/composables/useUser";
//Helpers
import { useStore } from '@/composables/useTypedStore';
import Immobilie from '@/models/immobilie.model';
import User from '@/models/user';
import { Map } from 'maplibre-gl';
import moment from 'moment';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateSurveyModal',
  props: {
  property: {
    type: Object,
    required: false,
  },
  templateIdentifier: {
    type: String,
    required: false
  }
},
  setup(__props) {

const props = __props;



//Variables
const router = useIonRouter();
const vueRouter = useRouter(); // ion router does not contain the current route
const { t } = useI18n({ useScope: 'global' });
const { user, canCreateUpdateObject } = useUser();
const store = useStore();
const featureFlags = computed(() => user.value?.organisation?.featureFlags);
const fetchedTemplates = ref([] as Array<any>);
const fetchedProperties = ref([] as Array<any>);
const body = ref({
  type: '',
  property: '',
  date: new Date(),
  name: '' as any,
  userId: user.value?.id as any,
  geolocationLon: null as null | number,
  geolocationLat: null as null | number
});
const customPositionChecked = ref(false);
const mapElement = ref<HTMLElement | null>(null);

//Computed Methods
const organisationPrefix: ComputedRef<string> = computed(() => {
  const currentUser: User | null = User.query().first();

  return currentUser ? currentUser.organisationPrefix : "";
});

const isMobileScreen = computed(() => {
  return store.getters["app/isMobile"];
});

const currentProject = computed(() => store.state.user.currentUserProject);

const isButtonActive = computed(() => {
  const isTypeSet = body.value.type !== '';
  const isPropertySet = body.value.property !== '';
  const isDateSet = body.value.date !== null && body.value.date !== undefined;
  const isNameSet = body.value.name !== '' && body.value.name !== null;
  const isGeolocationSet = body.value.geolocationLon !== null && body.value.geolocationLat !== null;

  const isBaseDataSet = isTypeSet && isDateSet && isNameSet && isPropertySet;

  if (!customPositionChecked.value && isBaseDataSet || customPositionChecked.value && isGeolocationSet && isBaseDataSet) {
    return true;
  } else {
    return false;
  }
});

const preparedTemplates = computed(() => {
  const data = fetchedTemplates.value?.map((item: any) => {
    return {
      id: item.id,
      label: item.attributes.vorlage.name.de,
      value: item.attributes.vorlage.uid,
      identifier: item.attributes.vorlage.identifier
    };
  });
  return data;
});

const preparedProjects = computed(() => {
  const data = fetchedProperties.value.map((item: any) => {
    return {
      id: item.id,
      label: `${item.name} (${item.externeObjektNr})`,
      value: item.id
    };
  });

  return data;
});

const routeName = computed(() => vueRouter.currentRoute?.value?.name ?? "");

//Lifecycle Hooks
onMounted(async () => {
  await FetchInitialData();
  populateInitData();
});

//Methods
const FetchInitialData = async () => {
  const cachedTemplates = await getCache('cachedSurveyTemplates');
  fetchedTemplates.value = JSON.parse(cachedTemplates);
  fetchedProperties.value = Immobilie.getters("moverObjects");
};

async function populateInitData() {
  body.value.userId = user.value?.id;
  body.value.name = user.value?.username;
  body.value.property = props.property ? props.property.id : '';
  body.value.type = props.templateIdentifier ? await findLatestVersion() : '';
}

async function findLatestVersion() {
  const templatesByIdentifier = preparedTemplates.value.filter(item => item.identifier === props.templateIdentifier);
  const templateVersions = templatesByIdentifier.map(item => item.value);
  const sortedVersions = templateVersions.sort(versionComparator);
  const latestVersions = sortedVersions[0];

  return latestVersions;
}

const versionComparator = (a: any, b: any) => {
  const getVersionNumbers = (str: string) => str.match(/v(\d+)\.(\d+)\.(\d+)/)?.slice(1).map(Number);

  const numbers1 = getVersionNumbers(a);
  const numbers2 = getVersionNumbers(b);

  if (numbers1?.length !== 3 || numbers2?.length !== 3) {
    return 0;
  }

  const [majorA, minorA, patchA] = numbers1;
  const [majorB, minorB, patchB] = numbers2;

  if (majorA !== majorB) {
    return majorB - majorA;
  } else if (minorA !== minorB) {
    return minorB - minorA;
  } else {
    return patchB - patchA;
  }
};

async function handleCreateProperty() {
  await modalController.dismiss();
  router.navigate('/create-property', 'forward', 'push');
}

async function sendData() {
  store.commit("app/setLoadingSpinner", true);
  store.commit('app/setCreateSurveyData', body.value);

  try {
    await cacheSelectedTemplate();
    const response = await useCreateSurvey().sendDataToBackend(body.value);
    router.navigate(`/ba/${response!.data.data.id}`, 'forward', 'pop');
  } catch (err: any) {
    router.navigate(`/ba/0.${Math.floor(Math.random() * 901) + 100}`, 'forward', 'pop');
  } finally {
    store.commit("app/setLoadingSpinner", false);
  }
  await modalController.dismiss();
}

async function cacheSelectedTemplate() {
  const selectedTemplate = fetchedTemplates.value.filter(item => item.attributes.uid === body.value.type)[0];
  await setCache('selectedSurveyTemplate', JSON.stringify(selectedTemplate));

  const selectedProperty = fetchedProperties.value.filter(item => item.id === body.value.property)[0];
  await setCache('selectedSurveyProperty', JSON.stringify(selectedProperty));
}

function onPositionChanged(event: any) {
  if (event.features[0]?.geometry.coordinates) {
    body.value.geolocationLon = event.features[0].geometry.coordinates[0];
    body.value.geolocationLat = event.features[0].geometry.coordinates[1];
  }
}

function clearMapSearchResult() {
  body.value.geolocationLon = null;
  body.value.geolocationLat = null;
}

function onMapLoaded(map: Map) {
  map.resize();
}

watch(customPositionChecked, async (newValue) => {
  if (newValue && !isMobileScreen.value) {
    const modal = await modalController.getTop();
    if (modal) {
      modal.style.setProperty("--width", "60%");
      modal.style.setProperty("--height", "80%");
      mapElement.value?.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }
  }
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(IonContent), null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)(`${organisationPrefix.value}createSurvey.modalTitle`)), 1),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)(`${organisationPrefix.value}createSurvey.type`)), 1),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(AppSelect, {
                  modelValue: body.value.type,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((body.value.type) = $event)),
                  items: preparedTemplates.value,
                  "initial-value": body.value.type,
                  placeholder: _unref(t)('createSurvey.selectTemplate')
                }, null, 8, ["modelValue", "items", "initial-value", "placeholder"])
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)(`${organisationPrefix.value}createSurvey.object`)), 1),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(AppSelect, {
                  modelValue: body.value.property,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((body.value.property) = $event)),
                  items: preparedProjects.value,
                  "initial-value": body.value.property,
                  placeholder: _unref(t)(`${organisationPrefix.value}createSurvey.selectObject`)
                }, null, 8, ["modelValue", "items", "initial-value", "placeholder"])
              ])
            ]),
            (_unref(canCreateUpdateObject) && !body.value.property && featureFlags.value?.createObject)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_unref(AButton), {
                    "btn-secondary": true,
                    class: "p-2",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (handleCreateProperty()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)(`${organisationPrefix.value}createSurvey.createObject`)), 1)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('createSurvey.customLocation.label')), 1),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_unref(IonItem), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonCheckbox), {
                      slot: "start",
                      checked: customPositionChecked.value,
                      onIonChange: _cache[3] || (_cache[3] = ($event: any) => (customPositionChecked.value = $event.detail.checked))
                    }, null, 8, ["checked"]),
                    _createVNode(_unref(IonLabel), { class: "text-xs" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('createSurvey.customLocation.enableCustomLocation')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            (customPositionChecked.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  ref_key: "mapElement",
                  ref: mapElement,
                  class: "position-selection pb-2 mb-2"
                }, [
                  _createVNode(AppMap, {
                    identifier: "surveyLocation",
                    "map-settings": currentProject.value.mapConfig?.createPropertyMap,
                    "allow-only-one-drawing": true,
                    "onUpdate:inputJson": onPositionChanged,
                    "onUpdate:clearMapSearchInputs": clearMapSearchResult,
                    "onMap:loaded": _cache[4] || (_cache[4] = ($event: any) => (onMapLoaded($event)))
                  }, null, 8, ["map-settings"])
                ], 512))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(t)('createSurvey.date')), 1),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_unref(IonItem), null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(new Date(body.value.date).toLocaleDateString('de-DE')) + " " + _toDisplayString(_unref(moment)(body.value.date).format('hh:mm')), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(t)('createSurvey.person')), 1),
              _createElementVNode("div", _hoisted_20, [
                _createVNode(AppInput, {
                  modelValue: body.value.name,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((body.value.name) = $event)),
                  readonly: true,
                  placeholder: _unref(t)('createSurvey.typing')
                }, null, 8, ["modelValue", "placeholder"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_unref(AButton), {
              disabled: isButtonActive.value ? false : true,
              "btn-primary": true,
              class: "px-16 py-6 text-lg",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (sendData()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)(`${organisationPrefix.value}createSurvey.createRecord`)), 1)
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_unref(AButton), {
              "btn-secondary": true,
              class: "px-16 py-6 text-lg",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(modalController).dismiss()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(routeName.value === "propertiesMap" ? _unref(t)('createSurvey.backToMap') : _unref(t)('createSurvey.backToOverview')), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_unref(IonModal), {
      trigger: "openDateTimeModal",
      size: "auto",
      class: "v2Modal dateTimeModal"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonContent), null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createVNode(AppDateTime, {
                  modelValue: body.value.date,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((body.value.date) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_unref(AButton), {
                  "btn-primary": true,
                  class: "px-16 py-6 text-lg",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_unref(modalController).dismiss()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('createSurvey.ok')), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})